module.exports = __webpack_public_path__ + "static/sliderThree-e228bd0fda3e0a194a85126524f79e4c.png";